export default "__VITE_ASSET__DKwoS$VX__"